export default "__VITE_PUBLIC_ASSET__062a2637__"